export default {
  'TOGGLE_STATE_HERE' (state, payload) {
    state.stateHere = payload
  }
}
